import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import useAxios from "../hooks/useAxios";
import { showAlert, isEmpty } from "../utils/site";
import { RESPONSE_TYPE } from "../consts/ResponseType";
import { MSG } from "../consts/Messages";
import { navigate } from "gatsby";
import { MenuContext } from "./MenuContext";
import {pageDefaults,menuSettingDefaults} from "./MenuContext"
import { AUTH_API } from "../consts/Endpoints";


export const AuthContext = createContext({
  logout: () => {}
});


const AuthContextProvider = ({ children }) => {

  
  const [request] = useAxios();
  const [isAuth, setIsAuth] = useState(0);
  const [severity, setSeverity] = useState(3);

  const {setPages, setMenuSettings,menuSettings} = useContext(MenuContext);



  const signUp = (username, password, email,callb,errCallb) => {
    request({
      url: AUTH_API+"api/signup",
      method: "post",
      headers: {
        'Content-type': 'application/json'
      },
      data: {
        username: username,
        password: password,
        email: email
      }

    }, (response) => {

      debugger;

      if (response.httpStatus) {
        throw response.message;
      }


      console.log(response);
      showAlert("Artık giriş yapabilirsin.", "success", "Üyeliğin oluşturuldu")
      callb();


    },(error) => {
      errCallb(error);
    });
  }



  const login = (userName, passport,callb,errCallb) => {

    request({
      url: AUTH_API+"api/login",
      method: "post",
      headers: {
        'Content-type': 'application/json'
      },
      data: {
        username: userName,
        password: passport
      }

    }, (response) => {

      debugger;

      if (response.httpStatus) {
        throw response.message;
      }

      if(!response.token){
        throw 'Lütfen Site Yöneticisine Başvurun! Token Yok!'
      }

      
      getUserInfo(response.token,callb);


    },(error) => {
      errCallb(error);
    });


  }


  /** Google ile giriş / kayıt (auth /api/google): Google kimlik jetonu + aydınlatma onayı + isteğe bağlı e-posta izni. */
  const googleGiris = (credential, epostaIzni, callb, errCallb, deneme = 1) => {
    request({
      url: AUTH_API + "api/google",
      method: "post",
      headers: { 'Content-type': 'application/json' },
      data: { credential, kvkk: true, epostaIzni: !!epostaIzni },
      // 2026-11-05: zaman aşımı yoktu; Azure soğukken / mobil ağ takılınca istek hiç bitmiyor, ekran "giriş yapılıyor"da kalıyordu
      timeout: 25000
    }, (response) => {
      if (!response || !response.token) {
        errCallb((response && response.hata) || "Giriş yapılamadı");
        return;
      }
      // Token geldiyse giriş tamam: hemen girişli say ve devam et (sayfa / bekleyen favori-alarm). Rol ve menü
      // (userinfo, Azure'a ikinci istek ~0,6-1 sn) arkada gelir; hata olursa getUserInfo oturumu sıfırlar.
      localStorage.setItem('token', response.token);
      setIsAuth(1);
      callb();
      getUserInfo(response.token, () => { });
    }, (error) => {
      // cevap hiç gelmediyse (zaman aşımı / ağ) bir kez daha dene: Google kimliği birkaç dakika geçerli
      if (deneme < 2 && !(error && error.response)) {
        googleGiris(credential, epostaIzni, callb, errCallb, deneme + 1);
        return;
      }
      errCallb((error && error.response && error.response.data && error.response.data.hata)
        || (error && !error.response ? "Sunucuya ulaşılamadı, tekrar dene" : "Giriş yapılamadı"));
    });
  }


  const getUserInfo = (token,callb) => {

    console.log('token '+token);
    request({
      url: AUTH_API+"secapi/userinfo",
      method: "post",
      headers: {
        'Content-type': 'application/json',
        'Authorization': 'Bearer '+token
      }
    }, (response) => {

      debugger;

      if (response.httpStatus) {
        localStorage.removeItem('token');
        setIsAuth(2);
        setSeverity(3);
        setPages(pageDefaults);
        throw response.message
        
      }

      setIsAuth(1);
      setSeverity(response.severity);
      //sessionStorage.setItem('token',token);
      localStorage.setItem('token',token);
      
      
      if (response.pages) {
        setPages([...pageDefaults,...response.pages]);
        // localStorage.setItem('pages',JSON.stringify(response.pages));
      }else {
        setPages(pageDefaults);
        // localStorage.setItem('pages',JSON.stringify(pageDefaults));
      }
      /*if(response.menuSettings){
        setMenuSettings(response.menuSettings)
      }*/
      setMenuSettings([...menuSettingDefaults,'Çıkış Yap']);
      console.log(response);
      callb();
      


    },(error) => {
      console.log(error.response.data);
      authSifirla();
      showAlert(error.response.data.message+ " ", RESPONSE_TYPE.ERROR, "Hata!");
    });











    /* let data = getFormData('userSessionService_getUserSessionInfo', null);
     request({
         url: ASSOS_USER_INFO_SERVICE,
         method: "post",
         headers: {
             ...data
         },
         data: data
     }, (response) => {
         if (!isEmpty(response?.error)) {
             showAlert(response?.messages[0].text, RESPONSE_TYPE.WARNING);
             sessionStorage.removeItem("token");
             setIsAuth(2);
         } else if (response?.data?.apps?.includes(GIB_MODUL.UZLASMA)) {
             setUserInfo({ ...response.data });
             setIsAuth(1);
         } else {  // Uzlaşma modülüne giriş için yetkisi yok ise;
             sessionStorage.removeItem("token");
             showAlert(MSG.UZLASMA_LOGIN_YETKI_YOK, RESPONSE_TYPE.WARNING);
             setIsAuth(2);
         }
     }); */
  }

  /*
  const getNonUserInfo = (callb) => {

    request({
      url: AUTH_API+"kategori/kategoriinfo",
      method: "post",
      headers: {
        'Content-type': 'application/json'
            }
    }, (response) => {

      setIsAuth(2);
      setSeverity(response.severity);
      if (response.pages) {
        setPages(response.pages)
        setKategoriPages(response.pages);
      }

      
      callb();
      


    },(error) => {
      debugger;
      console.log(error.response.data);
      authSifirla();
      showAlert(error.response.data.message+ " ", RESPONSE_TYPE.ERROR, "Hata!");
    });

  }
  */


  const logout = () => {

    // SSO falan olmadığı için ve jwt nin expiration date oldugu için direk session ı siliyoruz
    //sessionStorage.removeItem('token');
    localStorage.removeItem('token');
    // oturum durumu da sıfırlanmalı: yoksa sayfa yenilenene kadar header hâlâ girişli gösteriyordu (2026-11-02)
    setIsAuth(2);
    setSeverity(3);
    setMenuSettings(menuSettingDefaults);
    setPages(pageDefaults);
    
    showAlert("Görüşmek üzere 👋", 'success', "Çıkış yaptın")
    navigate('/');
    

    
    


    /* if (isEmpty(sessionStorage.getItem("token"))) {
       setUserInfo(null);
       sessionStorage.removeItem("token");
       setIsAuth(2);
     } else {
       let qs = require('qs');
       let data = qs.stringify({
         'assoscmd': ASSOS_LOGIN_TYPE.LOGOUT,
         'rtype': 'json',
         'token': sessionStorage.getItem("token"),
       });
       request({
         url: ASSOS_LOGIN_SERVICE,
         method: "post",
         headers: {
           'Content-Type': 'application/x-www-form-urlencoded'
         },
         data: data
       }, (response) => {
         if (!isEmpty(response?.error)) {
           showAlert(response?.messages[0].text, RESPONSE_TYPE.WARNING);
         } else {
           setUserInfo(null);
           sessionStorage.removeItem("token");
           setIsAuth(2);
         }
       });
     } */
  };

  // sadece backend exceptionlarda çağırılır 
  const authSifirla = () => {
    localStorage.removeItem('token');
    setIsAuth(2);
    setSeverity(3);
    setPages(pageDefaults);
    setMenuSettings(menuSettingDefaults);
  }


  /**
  *  Sayfa refresh olduğu zaman; userInfo bilgisi yeniden dolduruluyor. Ve Browser dan manuel routing yaptığında burası çalışır. 
  * Session storage a manuel token eklediğinde ve browserden manuel istek yaptıgında ilk burası değil AuthWrap çalışır.ORda da token varsa içeriye atıyor.
  * Her istekte token ı sorguladıgı için veri çekemez ama içerdeki sayfalarda gezinebilri
  * 
  * OLAYI ÇÖZDÜK auth işini state e bağladık. Ekstradan sessionStorage da da duruyor
  */
  useEffect(() => {
    /*if (sessionStorage.getItem("token") !== null) {
      getUserInfo(sessionStorage.getItem("token"),()=>{});
    } */
    debugger;
    if (localStorage.getItem("token") !== null) {
      getUserInfo(localStorage.getItem("token"),()=>{});
    } 
    else {
      debugger;
      setIsAuth(2);
      setSeverity(3);
      setPages(pageDefaults);
      
    }
  }, [])

  // TODO : burada pages, menuSettings değerlerini de eklemek gerekebilir
  // bu methodlar 1 kere oluşması yeterli ve util func olarak kullanılmamalı çünkü içinde state vs kullanıyoruz. Tam da context in bağlamında bulunmalı
  const values = useMemo(() => ({ isAuth,severity, login, logout,signUp, googleGiris }), [isAuth,severity]);


  return (
    <AuthContext.Provider value={values}>
      {children}
    </AuthContext.Provider>
  );


}

export default AuthContextProvider;